import { VetDataIntegrationSystem, SyncVetIntegrationSystem } from 'shared/types/graphql';

export type GenericIntegrationSystem = 'EZYVET' | 'INSTINCT' | 'NEO' | 'PIMS' | 'VETTER';

export type IntegrationSystemName = VetDataIntegrationSystem | GenericIntegrationSystem | SyncVetIntegrationSystem;

export type IntegrationSystemDisplayNameType =
  | 'Advantage'
  | 'AVImark'
  | 'ClienTrax'
  | 'Cornerstone'
  | 'Data Services'
  | 'Day Smart'
  | 'Digitail'
  | 'DVM Manager'
  | 'DVMax SQL'
  | 'EPet'
  | 'eVetPractice'
  | 'ezyVet'
  | 'Gingr'
  | 'GoosePet'
  | 'Hippo Manager'
  | 'Hvms'
  | 'ImproMed Triple Crown'
  | 'ImproMed'
  | 'Instinct'
  | 'IntraVet'
  | 'Logivet'
  | 'Neo'
  | 'Petware'
  | 'PIMS'
  | 'Provet Cloud'
  | 'Rhapsody'
  | 'Shepherd'
  | 'StringSoft'
  | 'Vetspire'
  | 'Vetter'
  | 'VIA'
  | 'VTP'
  | 'Woofware';

// Adjusts casing of integration system for user viewing
export const integrationSystemDisplayName: Record<IntegrationSystemName, IntegrationSystemDisplayNameType> = {
  ADVANTAGE: 'Advantage',
  AVIMARK: 'AVImark',
  CLIENTRAX: 'ClienTrax',
  CORNERSTONE: 'Cornerstone',
  CORNERSTONECLOUD: 'Cornerstone',
  DATASERVICES: 'Data Services',
  DAYSMART: 'Day Smart',
  DIGITAIL: 'Digitail',
  DVM_MANAGER: 'DVM Manager',
  DVMAX_SQL: 'DVMax SQL',
  EPET: 'EPet',
  EVETPRACTICE: 'eVetPractice',
  EZYVET: 'ezyVet',
  GINGR: 'Gingr',
  GOOSEPET: 'GoosePet',
  HIPPO_MANAGER: 'Hippo Manager',
  HIPPOMANAGER: 'Hippo Manager',
  HVMS: 'Hvms',
  IMPROMED_TRIPLECROWN: 'ImproMed Triple Crown',
  IMPROMED: 'ImproMed',
  INSTINCT: 'Instinct',
  INTRAVET: 'IntraVet',
  INTRAVETSQL: 'IntraVet',
  LOGIVET: 'Logivet',
  NEO: 'Neo',
  PETWARE: 'Petware',
  PIMS: 'PIMS',
  PROVETCLOUD: 'Provet Cloud',
  RHAPSODY: 'Rhapsody',
  SHEPHERD: 'Shepherd',
  STRINGSOFT: 'StringSoft',
  VETSPIRE: 'Vetspire',
  VETTER: 'Vetter',
  VIA: 'VIA',
  VTP: 'VTP',
  WOOFWARE: 'Woofware',
};
